import { SellerFeatures } from '../../enums/seller-features';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableCommittedInventoryCounts = () => {
  const isFeatureEnabled = useIsSellerFeatureEnabled(SellerFeatures.InventorySync);
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlagDeclarations.enableCommittedInventoryCount);
  return isFeatureEnabled || isFeatureFlagEnabled;
};
